import styled from 'styled-components'

interface IOrderItemTypeTagStyledProps {}

export const OrderItemTypeTagStyled = styled.div<IOrderItemTypeTagStyledProps>``
